import { Button, Layout, Skeleton, Tag, Typography } from "antd";
import React, { useEffect } from "react";
import {
  getInstitutionUsers,
  initInstitutionSlice,
} from "../Slices/Institution.slice";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../../shared/components/CustomTable";
import routes from "../../../engine/routes";
import { IoAddSharp } from "react-icons/io5";
import { renderUserName, subRolesCheckbox } from "../../../utils/constants";
import { UserCanDoActionMemo } from "../../../engine/AuthRoute";
import { useTranslation } from "react-i18next";

const { Content, Sider, Header, Footer } = Layout;

export function InstitutionUsers({ unitId, expanded, onClose }) {
  const { id } = useParams();

  const { institution, loading, users } = useSelector(
    state => state.institution,
  );

  const { init, clear } = initInstitutionSlice({ id });

  const dispatch = useDispatch();

  const { t } = useTranslation(); // Initialize useTranslation

  useEffect(() => {
    if (id !== "new") {
      dispatch(getInstitutionUsers(id));
    }
    return () => {};
  }, []);

  const columns = [
    {
      title: t("institutionUsers.columns.name"),
      width: "20%",
      dataIndex: "user",
      key: "user",
      render: (text, record) => renderUserName(record),
    },
    {
      title: t("institutionUsers.columns.email"),
      dataIndex: "email",
      width: "30%",
      key: "email",
    },
    {
      title: t("institutionUsers.columns.phone"),
      dataIndex: "info",
      key: "info",
      render: info => info?.phone,
    },
    {
      title: t("institutionUsers.columns.roles"),
      width: "30%",
      dataIndex: "subRoles",
      key: "subRoles",
      render: (subRoles, record) => (
        <div>
          {subRolesCheckbox()
            ?.filter(e => subRoles?.includes(e.value))
            .map(e => (
              <Tag key={e.value} style={{ margin: 2 }} color={"grey"}>
                {e.label}
              </Tag>
            ))}
        </div>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          {`${institution?.name} / ${t("institutionUsers.title")}`}
        </Typography.Title>
        <UserCanDoActionMemo
          route={routes.institutions(id).detailUsers}
          action={"c"}
        >
          <Link to={routes.institutions(id).newUserInstitution("new").path}>
            <Button
              size={"middle"}
              type={"primary"}
              style={{ justifySelf: "flex-start", display: "flex" }}
              icon={<IoAddSharp style={{ marginTop: "0px" }} size={25} />}
            >
              {t("institutionUsers.newUserButton")}
            </Button>
          </Link>
        </UserCanDoActionMemo>
      </div>
      <br />

      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomTable
            columns={columns}
            dataSource={users}
            onRowLink={record =>
              routes.institutions(id).detailUser(record._id).path
            }
          />
        </>
      )}
    </>
  );
}
